import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "campaigns-management__header" };
const _hoisted_2 = { class: "campaigns-management__title" };
const _hoisted_3 = ["disabled"];
import { reactive, onMounted, computed } from 'vue';
import { useStore } from 'vuex';
import { validateCampaignActivationRoute } from '@/helpers/verify-routes';
import ActiveActionsTable from '@/features/CampaignsManagement/components/ActiveActionsTable.vue';
import DeactiveActionsTable from '@/features/CampaignsManagement/components/DeactiveActionsTable.vue';
import router from '@/router';
export default /*#__PURE__*/ _defineComponent({
    __name: 'CampaignsManagement',
    setup(__props) {
        const state = reactive({
            isEditPriority: false,
        });
        const store = useStore();
        const createAction = () => {
            store.commit('campaignsManagement/SET_MODE', 'create');
            router.push({
                name: 'campaign-campaigns-create',
            });
        };
        const selectedTab = computed({
            get() {
                return store.state.campaignsManagement.tabSelected;
            },
            set(value) {
                store.commit('campaignsManagement/SET_TAB', value);
            },
        });
        onMounted(() => {
            if (!validateCampaignActivationRoute('campaign-campaigns'))
                router.push('/campaigns/campaigns');
        });
        return (_ctx, _cache) => {
            const _component_el_tab_pane = _resolveComponent("el-tab-pane");
            const _component_el_tabs = _resolveComponent("el-tabs");
            const _component_base_card_v2 = _resolveComponent("base-card-v2");
            return (_openBlock(), _createBlock(_component_base_card_v2, { class: "campaigns-management" }, {
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("strong", _hoisted_2, _toDisplayString(_ctx.$t('campaigns-management.title')), 1),
                        _createElementVNode("button", {
                            class: "btn",
                            disabled: state.isEditPriority,
                            onClick: createAction
                        }, _toDisplayString(_ctx.$t('campaigns-management.button')), 9, _hoisted_3)
                    ]),
                    _createVNode(_component_el_tabs, {
                        modelValue: selectedTab.value,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((selectedTab).value = $event))
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_el_tab_pane, {
                                label: _ctx.$t('campaigns-management.active-actions.tab'),
                                name: "active"
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(ActiveActionsTable, {
                                        selectedTab: selectedTab.value,
                                        onIsEditPriority: _cache[0] || (_cache[0] = value => (state.isEditPriority = value))
                                    }, null, 8, ["selectedTab"])
                                ]),
                                _: 1
                            }, 8, ["label"]),
                            _createVNode(_component_el_tab_pane, {
                                disabled: state.isEditPriority,
                                label: _ctx.$t('campaigns-management.deactive-actions.tab'),
                                name: "deactive"
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(DeactiveActionsTable, { selectedTab: selectedTab.value }, null, 8, ["selectedTab"])
                                ]),
                                _: 1
                            }, 8, ["disabled", "label"])
                        ]),
                        _: 1
                    }, 8, ["modelValue"])
                ]),
                _: 1
            }));
        };
    }
});
